/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { DisconnectData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    disconnectSettingsCalendar: build.mutation<DisconnectData, void>({
      query: () => ({ method: 'DELETE', url: `/v1/settings/calendar` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as disconnectSettingsCalendarApi };
export const { useDisconnectSettingsCalendarMutation } = injectedRtkApi;
